const stripWWW = (url: string) => {
  return url.replace(/^www\./i, '');
};
const checkIfShortenedURL = (url: URL) => {
  return stripWWW(url.hostname) === 'youtu.be';
};
const checkIfEmbedURL = (url: URL) => {
  return url.pathname.includes('/embed');
};
const getVideoIdFromShortURL = (url: URL): string | null => {
  return url.pathname === '/' ? null : url.pathname.split('/')[1];
};
const getVideoIdFromRegularURL = (url: URL): string | null => {
  if (stripWWW(url.hostname) === 'youtube.com' && url.pathname === '/watch') {
    return url.searchParams.get('v');
  }
  return null;
};
const getVideoIdFromEmbedURL = (url: URL): string | null => {
  if (
    stripWWW(url.hostname) === 'youtube.com' &&
    url.pathname.startsWith('/embed')
  ) {
    const parts = url.pathname.split('/');
    return parts[2];
  }
  return null;
};
const parseURL = (url: string): URL | null => {
  try {
    if (!url.startsWith('http')) {
      return new URL(`https://${url}`);
    }
    return new URL(url);
  } catch (error) {
    return null;
  }
};

const getYouTubeVideoIdFromURL = (url: string): string | null => {
  const parsedURL = parseURL(url);
  if (!parsedURL) return null;

  const isShortenedURL = checkIfShortenedURL(parsedURL);
  const isEmbedURL = checkIfEmbedURL(parsedURL);
  if (isShortenedURL) {
    return getVideoIdFromShortURL(parsedURL);
  } else if (isEmbedURL) {
    return getVideoIdFromEmbedURL(parsedURL);
  }
  return getVideoIdFromRegularURL(parsedURL);
};
const getYouTubeVideoThumbnailFromId = (id: string) => {
  return `https://img.youtube.com/vi/${id}/0.jpg`;
};

const getWatchURLFromEmbeddedURL = (embedUrl: string): string => {
  return embedUrl?.replace('/embed/', '/watch?v=');
};
const getYouTubeVideoIframeURLFromId = (id: string) => {
  return `https://youtube.com/embed/${id}?rel=0&showinfo=0&autohide=1&modestbranding=1`;
};

export {
  getYouTubeVideoIdFromURL,
  getYouTubeVideoThumbnailFromId,
  getYouTubeVideoIframeURLFromId,
  getWatchURLFromEmbeddedURL,
};
